import { SxProps, Theme } from '@mui/material';

const queueContainer: SxProps<Theme> = {
  padding: 2,
  marginY: 2,
};

const addQuestionButton: SxProps<Theme> = {
  marginTop: { xs: 1, md: 0 },
};

const styles = {
  queueContainer,
  addQuestionButton,
};

export default styles;
